import { CellContext, Row, Table, flexRender } from '@tanstack/react-table';
import { ReactNode } from 'react';

import { CellContents } from '../columns/cell-contents';

const ACTION_CELLS = new Set(['select', 'expand']);

interface GroupRowProps<T> {
  row: Row<T>;
  table: Table<T>;
}

export const GroupRow = <T,>(props: GroupRowProps<T>) => {
  const { row, table } = props;

  const visibleCells = row?.getVisibleCells() || [];

  let actionCells: ReactNode[] = [];

  for (const cell of visibleCells) {
    if (!ACTION_CELLS.has(cell.column.id)) continue;
    actionCells = [...actionCells, <CellContents<T> key={cell.id} cell={cell} classNames="group-td" />];
  }

  return (
    <tr key={row?.id} className="bg-gray-50 ">
      {actionCells}
      <td style={{ left: `${actionCells.length * 60}px` }} className={`body-td-sticky group-td  w-6 overflow-visible`}>
        <div className="flex w-6 items-center overflow-visible ">
          {flexRender(
            table.getColumn(table.getState().grouping[0])?.columnDef.aggregatedCell,
            row
              .getAllCells()
              .find((c) => c.column.id === table.getState().grouping[0])
              ?.getContext() as CellContext<T, unknown>
          )}
        </div>
      </td>
      {[...visibleCells].slice(actionCells.length + 1, visibleCells.length).map((cell) => {
        return <td className="group-td body-td inherit-bg sticky px-4 py-2" key={cell.id} />;
      })}
    </tr>
  );
};
